export const VIRTUAL_MODULES = {
  startManifest: 'tanstack-start-manifest:v',
  serverFnResolver: '#tanstack-start-server-fn-resolver',
  pluginAdapters: '#tanstack-start-plugin-adapters',
} as const
